import { render, staticRenderFns } from "./mrc_ess_chooseStaff.vue?vue&type=template&id=a671b2cc&scoped=true&"
import script from "./mrc_ess_chooseStaff.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_chooseStaff.vue?vue&type=script&lang=js&"
import style0 from "./mrc_ess_chooseStaff.vue?vue&type=style&index=0&id=a671b2cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a671b2cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VImg,VProgressCircular,VTab,VTabItem,VTabs,VTabsItems})
